import Vue from 'vue'
import Component from 'vue-class-component'
import Board from './board/index.vue'
import Chat from './chat/index.vue'
import Navigator from './navigator/index.vue'
import Stock from './stock/index.vue'
import Players from './players/index.vue'
import ChooseFat from './modals/choose-fat/index.vue'
import CreateTag from './modals/create-tag/index.vue'
import WinGame from './modals/win-game/index.vue'
import Assignments from './modals/assignments/index.vue'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'
import { Watch } from 'vue-property-decorator'
import { capitalizeFirstLetter } from '@/shared/utils'

@Component({
  components: {
    vgbBoard: Board,
    vgbChat: Chat,
    vgbNavigator: Navigator,
    vgbStock: Stock,
    vgbChooseFat: ChooseFat,
    vgbCreateTag: CreateTag,
    vgbAssignments: Assignments,
    vgbPlayers: Players,
    vgbWinGame: WinGame,
  },
})
export default class Game extends mixins(MixinGame) {
  public assignmentsVisible: boolean = false

  @Watch('gameIsWonByTeam', { immediate: true })
  public onGameIsWonByTeam() {
    this.$modal.open('win-game')
  }

  @Watch('turnID', { immediate: true })
  public onTurnIDchange() {
    if (this.activePlayer.name !== '') {
      this.$flits.info(`${capitalizeFirstLetter(this.activePlayer.name)} is aan de beurt.`)
    }
  }

  public showAssignments() {
    this.assignmentsVisible = true
    this.$modal.open('assignments')
  }

  public hideAssignments() {
    this.assignmentsVisible = false
  }
}
